import React, { useState, useEffect } from 'react';
import NavigationBar from '../NavigationBar';
import axios from '../axios';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';

const FIELDS = [
    { key: 'company_name', label: 'Company name (as on documents)' },
    { key: 'factory_address', label: 'Factory address' },
    { key: 'business_address', label: 'Business / registered address' },
    { key: 'irc_no', label: 'IRC number' },
    { key: 'tin_no', label: 'TIN number' },
    { key: 'bin_no', label: 'BIN number' },
    { key: 'bond_license', label: 'Bond license' },
    { key: 'default_hs_code', label: 'Default HS code' },
    { key: 'signatories', label: 'Signatories (one per line)', textarea: true, isList: true },
];

function PurchaseSettings() {
    const [values, setValues] = useState({});
    const [saving, setSaving] = useState(false);

    useEffect(() => { fetchSettings(); }, []);

    const fetchSettings = async () => {
        try {
            const res = await axios.get(`${window.backendUrl}/purchase_settings`);
            const raw = res.data.data || {};
            const next = {};
            FIELDS.forEach(f => {
                if (f.isList) {
                    try {
                        const arr = raw[f.key] ? JSON.parse(raw[f.key]) : [];
                        next[f.key] = Array.isArray(arr) ? arr.join('\n') : (raw[f.key] || '');
                    } catch (e) { next[f.key] = raw[f.key] || ''; }
                } else {
                    next[f.key] = raw[f.key] || '';
                }
            });
            setValues(next);
        } catch (err) {
            console.error('Error fetching settings:', err);
        }
    };

    const handleChange = (key, value) => setValues(prev => ({ ...prev, [key]: value }));

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {};
            FIELDS.forEach(f => {
                if (f.isList) {
                    const arr = (values[f.key] || '').split('\n').map(s => s.trim()).filter(Boolean);
                    payload[f.key] = JSON.stringify(arr);
                } else {
                    payload[f.key] = values[f.key] || '';
                }
            });
            await axios.put(`${window.backendUrl}/purchase_settings`, { settings: payload });
            alert('Settings saved.');
        } catch (err) {
            console.error('Error saving settings:', err);
            alert('Failed to save settings.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <NavigationBar />
            <Container fluid style={{ marginTop: 20, marginBottom: 40 }}>
                <Row className="mb-3"><Col><h3>Purchase Settings</h3><p className="text-muted">Used to fill in the PO, LC request and retirement letters. Each company keeps its own copy.</p></Col></Row>
                <Row>
                    <Col md={8}>
                        <Card body>
                            {FIELDS.map(f => (
                                <Form.Group className="mb-3" key={f.key}>
                                    <Form.Label>{f.label}</Form.Label>
                                    <Form.Control
                                        as={f.textarea ? 'textarea' : 'input'}
                                        rows={f.textarea ? 3 : undefined}
                                        value={values[f.key] || ''}
                                        onChange={e => handleChange(f.key, e.target.value)}
                                    />
                                </Form.Group>
                            ))}
                            <Button variant="primary" onClick={handleSave} disabled={saving}>
                                {saving ? 'Saving...' : 'Save Settings'}
                            </Button>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PurchaseSettings;
